export default "__VITE_ASSET__c9b91974__"